import { IGeocodingResultTypeEnum } from 'types/graphqlTypes'
import { TGeocodingResultType } from '../types'
import { getResultTypeEnum } from './getResultTypeEnum'

/**
 * @example getResultTypes(['City', 'State']) // [IGeocodingResultTypeEnum.City, IGeocodingResultTypeEnum.State]
 */
export const getResultTypes = (
  keyNames?: TGeocodingResultType[]
): IGeocodingResultTypeEnum[] | undefined => {
  if (!keyNames || keyNames.length < 1) {
    return undefined
  }

  return keyNames.map(getResultTypeEnum)
}
